import { FC } from "react";
import { Outlet } from "react-router-dom";
import { useAppSelector } from "../hooks/ReduxHooks";
import Loader from "../components/UI/loader/Loader";
import NotFoundPage from "../components/pages/not-found/NotFoundPage";
import { operatorRole } from "../redux/types/OperatorTypes";

const GSCRoute: FC = () => {
  const { operator, authLoading, isAuthChecked } = useAppSelector(
    (state) => state.operator,
  );

  if (authLoading || !isAuthChecked) {
    return <Loader />;
  }

  const isDev = operator?.role === operatorRole.DEV;
  const isGSC = operator?.role === operatorRole.CENTER_OPERATOR;

  if (isDev || isGSC) {
    return <Outlet />;
  }

  return <NotFoundPage />;
};

export default GSCRoute;
